<span class="" [innerHTML]="text|appTranslate|async">
</span>